import React from 'react';
import styled from 'styled-components';
import { Switch, Route, Redirect } from 'react-router-dom';

import routes from '../../routes';
import Title from '../Util/Title';
import usePrivileges, { hasPrivilege } from '../Util/usePrivileges';

interface Props {}

const Wrapper = styled.div`
  /* margin-left: 80px; */
  height: 100%;
  width: 100%;
  overflow: auto;
`;

const Main: React.FunctionComponent<Props> = (props) => {
  const privileges = usePrivileges();
  return (
    <main>
      <Wrapper>
        <Switch>
          {routes
            .filter(
              (route) => (route.privileges ? hasPrivilege(privileges, route.privileges) : true) && route.mainComponent
            )
            .map((route) => (
              <Route key={route.path} path={route.path} component={route.mainComponent} />
            ))}
          <Redirect
            to={{
              pathname: '/sessions',
            }}
          />
        </Switch>
        <Switch>
          {routes
            .filter((route) => (route.privileges ? hasPrivilege(privileges, route.privileges) : true))
            .map((route) => (
              <Route key={route.path} path={route.path} render={() => <Title title={route.title || 'Aap'} />} />
            ))}
        </Switch>
      </Wrapper>
    </main>
  );
};

export default Main;
